export default "__VITE_ASSET__CAP6MLyj__"